import videoCafe from "../assets/videos/cafe-coco.mp4";
import videoInmobiliaria from "../assets/videos/demo-gestorInmobiliario.mp4";
import videoBilletera from "../assets/videos/paypy.mp4";

/* =========================
   PROYECTOS DESARROLLO
========================= */

export const PROJECTS_DEV = [
  {
    title: "SISTEMA DE GESTIÓN DE CLIENTES Y PRODUCTOS",
    description:
      "Sistema para gestión de clientes, productos, stock y ventas. Permite trabajar incluso sin conexión a internet.",
    techs:
      "React, PostgreSQL, Bootstrap, Node.js, Express",
    github:
      "https://github.com/FaniCasco/GESTION-DE-PRODUCTOS-CAFE",
    demo: videoCafe,
  },

  {
    title: "GESTOR DE CLIENTES INMOBILIARIOS",
    description:
      "Aplicación para administración de inquilinos y propietarios con edición de datos, generación de recibos PDF y envío por WhatsApp.",
    techs:
      "React, Node.js, PostgreSQL, Bootstrap",
    github:
      "https://github.com/FaniCasco/GESTION-DE-CLIENTES",
    demo: videoInmobiliaria,
  },

  {
    title: "SISTEMA DE GESTIÓN HOTELERA",
    description:
      "Sistema administrativo para gestión de reservas, habitaciones, huéspedes y cobros.",
    techs:
      "React, Node.js, Bootstrap",
    github:
      "https://github.com/FaniCasco/Sistema-de-gestion-Hotelera",
    demo:
      "https://sistema-hotel.vercel.app/",
  },

  {
    title: "E-COMMERCE COMIDA RÁPIDA",
    description:
      "Sitio web responsive para venta de comida rápida con diseño visual dinámico y experiencia enfocada en usabilidad.",
    techs:
      "React, Bootstrap, HTML5, CSS3",
    github:
      "https://github.com/FaniCasco/PROYECTO-GRUPAL-2-CILSA",
    demo:
      "https://lusafastfood.vercel.app/",
  },

  {
    title: "BILLETERA VIRTUAL",
    description:
      "Aplicación desarrollada en equipo utilizando Python y Tkinter para gestión de pagos, servicios y movimientos financieros.",
    techs:
      "Python, Tkinter",
    github:
      "https://github.com/FaniCasco/PAYPY",
    demo: videoBilletera,
  },

  {
    title: "PLATAFORMA STREAM REACTV",
    description:
      "Aplicación web desarrollada con React y Firebase que consume la API de TMDB para mostrar películas y series.",
    techs:
      "React, Firebase, TMDB API",
    github:
      "https://github.com/FaniCasco/Plataforma-Stream-ReacTv",
    demo:
      "https://23644-grupo1-reac-tv.vercel.app/",
  },

  {
    title: "DULCES HUMAYA",
    description:
      "Sitio responsive de recetas construido con React consumiendo API externa.",
    techs:
      "React, Bootstrap, API",
    github:
      "https://github.com/FaniCasco/REACT-TP-HUMAYA",
    demo:
      "https://react-tp-humaya.vercel.app/",
  },

  {
    title: "HOUSE HERRAMIENTAS",
    description:
      "Primer proyecto web orientado a e-commerce con múltiples páginas y optimización SEO.",
    techs:
      "HTML5, CSS3, Bootstrap, JavaScript",
    github:
      "https://github.com/FaniCasco/PROYECTO-FINAL-CODER",
    demo:
      "https://househerramientas.vercel.app/",
  },
];

/* =========================
   PROYECTOS FIGMA
========================= */

export const PROJECTS_FIGMA = [
  {
    title: "MERCADO PAGO ACCESIBLE",
    description:
      "Prototipo UX/UI realizado en Figma durante el curso de Accesibilidad y UX. Se trabajó sobre mejoras inclusivas para personas con distintas necesidades visuales y cognitivas mediante cambios de colores, sonidos y accesibilidad.",
    techs:
      "Figma, UX/UI, Accesibilidad",
    demo:
      "https://www.figma.com/proto/WHTwHRr0OMoPx2w0rUqgXz/MERCADO-PAGO?node-id=2-6&t=vbo9nWi0xxiXUiIn-1&starting-point-node-id=2%3A6",
  },

  {
    title: "PADEL RESERVE",
    description:
      "Proyecto colaborativo donde participé como Scrum Master y en el diseño inicial de pantallas en Figma. Fue una experiencia clave para aprender trabajo en equipo y fundamentos de diseño de interfaces.",
    techs:
      "Figma, Scrum, UX/UI, Angular, Node.js",
     demo:
      "https://www.figma.com/design/vqSxPwCMkqQIdDILuqxcvI/Padel-Reserve---Prototipo?node-id=1-3&t=1wjOH84xCr8EY5GM-0",
  },
];
